import type { Language } from '../types/language';

export interface Reel {
  id: string;
  title: Record<Language, string>;
  format: 'vertical' | 'landscape';
  poster: string;
}

export const reels: Reel[] = [
  {
    id: 'Lj0qp73MGgw',
    title: { en: 'Professional performance reel', es: 'Reel de performance profesional' },
    format: 'landscape',
    poster: 'https://i.ytimg.com/vi/Lj0qp73MGgw/maxresdefault.jpg',
  },
];
